export default function Header({ show }) {
  if (!show) return <></>;
  return <h1 className="text-center fs-1">Memorice</h1>;
}
